import { Block, Section } from 'src/editor/content-creation/types';

export function createRect(rect: any) {
  if (rect == null) {
    return null;
  }
  let newRect = {
    left: rect.left + document.body.scrollLeft,
    top: rect.top + document.body.scrollTop,
    width: rect.width,
    height: rect.height,
    bottom: 0,
    right: 0,
  };
  newRect.bottom = newRect.top + newRect.height;
  newRect.right = newRect.left + newRect.width;
  return newRect;
}

export function absoluteRect(element: HTMLElement) {
  return createRect(element.getBoundingClientRect());
}

export function removeNode(node: any) {
  if (node && node.parentNode) {
    node.parentNode.removeChild(node);
  }
}

export function dom(tagName: string, options: any, editorView: any) {
  const { className, draggable, onDragStart } = options;

  let dropElement = document.createElement(tagName);
  dropElement.setAttribute('draggable', draggable || false);
  dropElement.className = className || '';
  dropElement.addEventListener('dragstart', (e) => onDragStart(e, editorView));
  dropElement.textContent = '⠿';

  return dropElement;
}

export const isBlockEmpty = (block: Block) => {
  //
  if (block.content.type === 'text') {
    let value = block.content.value;
    value = value.replace(/<[^>]*>?/gm, '');
    value = value.replace(/&nbsp;/g, '');
    value = value.replace(/&amp;/g, '');

    return value.trim().length === 0;
  } else if (block.content.type === 'placeholder') {
    return true;
  }

  return false;
};

export const isSectionEmpty = (section: Section) => {
  const hasNoBlocks = section.blocks.length === 0;
  const hasOnlyEmptyBlocks = section.blocks.every(isBlockEmpty);

  return hasNoBlocks || hasOnlyEmptyBlocks;
};
